export const EMenuActionsTypes = {
	all: 'all',
	searchResults: 'searchResults',
} as const;
